import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Let Bootstrap handle the escape key for modals
    // Only add custom behavior if this isn't a Bootstrap modal
    const isBootstrapModal = this.element.classList.contains('modal');
    
    if (!isBootstrapModal) {
      // Store bound function reference for proper cleanup
      this.boundHandleEscape = this.handleEscape.bind(this);
      document.addEventListener('keydown', this.boundHandleEscape);
    } else {
      // For Bootstrap modals, listen to the hide event instead
      this.element.addEventListener('hide.bs.modal', this.handleModalHide.bind(this));
    }
  }

  handleEscape(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
  
  handleModalHide(event) {
    // Prevent default modal close behavior
    event.preventDefault();
    // Navigate away instead
    this.close();
  }

  close() {
    // Navigate to the registration page using Rails router
    window.location = this.getRegistrationPath();
  }

  getRegistrationPath() {
    // Get the signup path from a meta tag or return the default path
    return '/users/sign_up';
  }

  disconnect() {
    // Clean up event listeners
    if (this.boundHandleEscape) {
      document.removeEventListener('keydown', this.boundHandleEscape);
    }
    
    // Remove Bootstrap modal event listener if it exists
    if (this.element.classList.contains('modal')) {
      this.element.removeEventListener('hide.bs.modal', this.handleModalHide.bind(this));
    }
  }
}